<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <div class="container">
          <div class="container--descriptions">
            Clique abaixo para ser redirecionada(o) para a
            <strong>Calculadora para estratificação de risco cardiovascular</strong> da Sociedade Brasileira de
            Cardiologia:
          </div>

          <a
            target="_blank"
            href="http://departamentos.cardiol.br/sbc-da/2015/CALCULADORAER2017"
          >
            <button class="container--button">
              CALCULADORA RISCO CARDIOVASCULAR SBC
              <svg-loader
                src="/static/images/icon-external-link.svg"
                class="external-link"
              />
            </button>
          </a>
          <p class="container--link-help">
            Caso tenha algum problema ao acessar o link, entre em contato no
            <a href="https://alvaroapoio.com.br/fale-conosco">Fale conosco</a>
          </p>
        </div>
      </md-layout>
    </md-layout>
  </div>
</template>
<script>
export default {
  name: 'RiscoCardiovascular'
}
</script>
<style lang="scss">
  .container {
    width: 100%;
    &--descriptions {
      font-size: 13px;
      color: #818181;
    }
    &--button {
      margin-top: 24px;
      margin-bottom: 24px;
      width: 100%;
      height: 32px;
      background: white;
      color: #7f1a54;
      border: 2px solid #7f1a54;
      border-radius: 4px;
      font-weight: 600;
      font-size: 11px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Exo 2', sans-serif !important;
      .md-icon {
        width: 14px;
        min-width: 14px;
        margin: 0 0 0 10px;
      }
    }

    &--link-help {
      justify-content: center;
      font-size: 11px !important;
      font-weight: normal !important;
      text-align: center;
      a {
        font-size: 11px;
        font-weight: 400;
        color: #7f1a54 !important;
      }
    }
  }
  a {
    text-decoration: none !important;
  }
</style>
